






import { Vue, Prop, Component } from 'vue-property-decorator';
import Link from '@/components/Atoms/Link/BreadcrumbsLink.vue';

@Component({
  components: {
    Link,
  },
})
export default class Item extends Vue {
  @Prop() private text!: string;
  @Prop() private link?: string;
}
